<template>
  <div class="item"><slot></slot></div>
</template>

<script>
export default {
  name: 'xm-popover-item'
};
</script>


<style lang="less" scoped>
@import '../core/mixins.less';

@border-color: rgba(0, 0, 0, .2);

.item {
  width: auto;
  padding: .01rem;
  + .item {
    position: relative;
    .hairline(top, @border-color);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PopoverItem.vue